module.exports = __webpack_public_path__ + "static/media/Avisha_headshot.08e6451a.png";